var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeeMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "see_more",
    transform: "translate(-1485 -814)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11287",
    "data-name": "Rectangle 11287",
    width: 95,
    height: 95,
    rx: 4,
    transform: "translate(1485 814)",
    fill: "#eaecf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_right",
    d: "M25.428,5.342a2,2,0,0,0-1.442.62l-.175.181a2.148,2.148,0,0,0,0,2.974l7.877,8.124H5.039a2.1,2.1,0,0,0,0,4.206H31.688l-7.877,8.124a2.147,2.147,0,0,0,0,2.974l.175.181a1.993,1.993,0,0,0,2.883,0L38.4,20.83a2.147,2.147,0,0,0,0-2.974L26.869,5.962A2,2,0,0,0,25.428,5.342Z",
    transform: "translate(1512 842.658)",
    fill: "#4b4e6d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeMore);
export default __webpack_public_path__ + "static/media/see_more.0fe9cf1cbea9a8669982def51e44469f.svg";
export { ForwardRef as ReactComponent };